const telescupImageBase = (
  import.meta.env.VITE_TELESCUP_API_BASE || "https://cdn.telescup.com.br"
).replace(/\/+$/u, "");

const buildTelescupImageUrl = (
  assetId: string,
  dimensions: { width: number; height: number },
): string => {
  const query = new URLSearchParams({
    id: assetId,
    w: String(dimensions.width),
    h: String(dimensions.height),
    fit: "contain",
    format: "png",
    q: "88",
  });

  return `${telescupImageBase}/i?${query.toString()}`;
};

export const resolveNaveAvatar = (avatarRef: string): string | undefined => {
  const value = avatarRef.trim();
  if (!value || value.length > 2048) return undefined;
  if (/^https:\/\//iu.test(value)) {
    try {
      const url = new URL(value);
      if (url.hostname !== "cdn.telescup.com.br" && !url.hostname.endsWith(".telescup.com.br")) return undefined;
      return url.href;
    } catch { return undefined; }
  }
  if (!/^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/iu.test(value)) return undefined;
  const query = new URLSearchParams({ id: value, w: "300", h: "300", fit: "cover", format: "avif", q: "60" });
  return `https://cdn.telescup.com.br/i?${query.toString()}`;
};

export const naveBrandAssets = {
  cupcodeIcon: buildTelescupImageUrl("da4ddf59-45a1-4b0a-a5b2-12939865f4bd", { width: 64, height: 64 }),
  accountMenu: buildTelescupImageUrl("7c4703e1-b51e-4f7d-b672-819d78c65143", { width: 88, height: 88 }),
  icon: buildTelescupImageUrl("caf038a6-1251-4f17-a696-175183670ffb", { width: 64, height: 64 }),
  squareLogo: buildTelescupImageUrl("0f77d7a8-a561-4ac4-8fbc-f0dc6880e48a", { width: 583, height: 606 }),
  horizontalLogo: buildTelescupImageUrl("d512c16e-4440-440b-b985-39c267f75383", { width: 853, height: 268 }),
} as const;
